/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
var buildSidebarMenu = function buildSidebarMenu() {
  var $menu = $("[data-menu-container]");
  var $blocks = $("[data-menuable] [data-content-block], [data-menuable] > .component-richtext h2[id]");
  var items = [];
 
  $blocks.each(function(i, elm) {
    if (!$(elm).data('content-block-no-menu')) {
      return items.push(
        $('<li class="mb4"/>').addClass(
          !$(elm).data('content-block-locked') || 'locked'
        ).addClass(
          !$(elm).data('content-body-locked') || 'locked'
        ).append(
          $('<a class="fw6 no-underline"/>').text(
            $(elm).data('content-block-heading') || elm.textContent
          ).attr(
            'href',
            '#' + ($(elm).data('content-block-anchor') || elm.id)
          )
        )
      );
    }
  });

  return $menu.append(items);
};

$('.accordian-wrap-header').click(function() {
  if ($(this).parent().hasClass('wrap-rm-open')) {
    $(this).parent().removeClass('wrap-rm-open');
  } else {
    $(this).parent().addClass('wrap-rm-open');
  }
});

$(document).ready(function() {
  $(location.hash).addClass('wrap-rm-open');
  if ($("[data-menu-container]").length > 0) { return buildSidebarMenu(); }
});